import React from 'react'
import PropTypes from 'prop-types'
import ReactPIXI from '@manychat/react-pixi'

import app from 'common/builder/components/chart/FlowChart/app'

export default class Portal extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    to: PropTypes.string,
  }

  state = {}

  componentDidMount = () => {
    app.on('nodeAdded', this.updateElement)
    app.on('nodeDeleted', this.updateElement)
    this.updateElement()
  }

  componentWillUnmount = () => {
    app.removeListener('nodeAdded', this.updateElement)
    app.removeListener('nodeDeleted', this.updateElement)
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.to !== prevProps.to) {
      this.updateElement()
    }
  }

  updateElement = () => {
    const { to } = this.props
    const container = app.getNode(to)
    if (container !== this.state.container) {
      this.setState({ container })
    }
  }

  render() {
    const { container } = this.state
    const { children } = this.props

    if (!container) {
      return null
    }

    return ReactPIXI.createPortal(children, container)
  }
}
